import i18n from '@/i18n';

const state = {
  languages: []
}

const getters = {
  languages: (state) => {
    return state.languages
  }
}

const actions = {
  setLocale({commit}, locale) {
    i18n.locale = locale;
    commit('SET_LOCALE', locale);
  },
  setLanguages({commit}, languages) {
    commit('SET_LANGUAGES', languages);
  }
}

const mutations = {
  SET_LOCALE(state, locale) {
    localStorage.setItem('lang', locale);
  },
  SET_LANGUAGES(state, languages) {
    state.languages = languages;
  }
}

export const Localization = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}